import React from 'react';

import TextBox from 'RLX/Forms/TextBox';

class NumberBox extends React.Component {
  constructor (props) {
    super(props);
  }

  render () {
    const { props } = this;
    return <TextBox {...props} fieldType="number" />
  }
};

export default NumberBox;



// WEBPACK FOOTER //
// ./client/RLX/Forms/NumberBox.jsx